import List, { PROPERTY_PLAN } from "./list";

function PropertyPlans() {
  return <List type={PROPERTY_PLAN} />;
}

export default PropertyPlans;
